import {
  DEFAULT_FORMATS as BASE_DEFAULT_FORMATS,
  defaultCurrencyFormat as baseDefaultCurrencyFormat,
} from '@quintoandar/js-intl/base';

export * from '@quintoandar/js-intl/base';

const namedDateFormats = {
  date: {
    'dd/mm/yyyy': {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    },
    'weekday-day-month-hour-minute': {
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      month: 'long',
      weekday: 'long',
    },
  },
};

export const DEFAULT_FORMATS = {
  ...BASE_DEFAULT_FORMATS,
  ...namedDateFormats,
};

export const defaultCurrencyFormat = (...args) => ({
  ...baseDefaultCurrencyFormat(...args),
  ...namedDateFormats,
});
